import { SingularResponse } from 'coloquent/dist/response/SingularResponse'
import { Model } from '@/models/Model'
import { PluralResponse } from 'coloquent/dist/response/PluralResponse'
import { Query } from 'coloquent/dist/Query'

export function createModelFromResponse<T extends Model>(model: new () => T, payload): T | null {
	const newModel = new SingularResponse(
		// @ts-ignore
		undefined,
		undefined,
		model,
		payload
	).getData() as T | null

	if (!newModel) return null
	newModel.setApiId(payload.data.id)

	return newModel
}

export function createModelsFromResponse<T extends Model>(model: new () => T, payload): Array<T> | null {
	return new PluralResponse(
		// eslint-disable-next-line new-cap
		new Query(new model().getJsonApiType()),
		// @ts-ignore
		undefined,
		model,
		payload
	).getData() as Array<T> | null
}
